import { render, staticRenderFns } from "./DraftPriceChangeRequestDecision.vue?vue&type=template&id=52bdc806&"
import script from "./DraftPriceChangeRequestDecision.vue?vue&type=script&lang=js&"
export * from "./DraftPriceChangeRequestDecision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports